import { useMutation } from '@apollo/client';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSnackbar } from 'notistack';
import React from 'react';
import { RELIST_POST, UNLIST_POST } from '../../../helpers/graphql/posts';

export default function UnlistDialog({
  open,
  btnText,
  dialogText,
  setOpen,
  setIsUnlisted,
  isUnlisted,
  permlink,
}) {
  const [changeVisbility] = useMutation(isUnlisted ? RELIST_POST : UNLIST_POST);

  const { enqueueSnackbar } = useSnackbar();

  const handleChangeVisibility = () => {
    changeVisbility({
      variables: {
        permlink,
      },
    })
      .then(({ data }) => {
        const isSuccess = isUnlisted ? data.relistPost : data.unlistPost;
        if (isSuccess) {
          setOpen(false);
          setIsUnlisted(!isUnlisted);
        } else {
          enqueueSnackbar(
            `Changing visibility unsuccessful: ${
              isUnlisted ? data.relistPost.message : data.unlistPost.message
            }`,
            {
              variant: 'error',
            },
          );
        }
      })
      .catch(() => {
        enqueueSnackbar('Changing visibility unsuccessful', {
          variant: 'error',
        });
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{btnText}?</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} color="primary">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleChangeVisibility}
          color="primary"
        >
          {btnText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
